import { useDispatch } from "react-redux";
import Project from "./Project";
import { initFilter } from "../redux/features/filter/filterSlice";
import { useGetProjectsQuery } from "../redux/features/projects/projectsApi";

export default function Projects() {
  const { data: projects, isLoading, isError, error } = useGetProjectsQuery();

  const dispatch = useDispatch();

  let content = null;

  // is loading
  if (isLoading) {
    content = <div>Loading...</div>;
  }

  // is not loading and error
  else if (!isLoading && isError) {
    content = <div>{error}</div>;
  }

  // is not loading and no error and no projects
  else if (!isLoading && !isError && projects?.length === 0) {
    content = <div>No Projects Found!</div>;
  }

  // is not loading and no error and have projects
  else if (!isLoading && !isError && projects?.length > 0) {
    dispatch(initFilter(projects));
    content = projects.map((project) => (
      <Project key={project.id} project={project} />
    ));
  }

  return (
    <div>
      <h3 className="text-xl font-bold">Projects</h3>
      <div className="mt-3 space-y-4">{content}</div>
    </div>
  );
}
